import { render, staticRenderFns } from "./CategoryGridItem.vue?vue&type=template&id=4cd63d42&"
import script from "./CategoryGridItem.vue?vue&type=script&lang=js&"
export * from "./CategoryGridItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports